module.exports = __webpack_public_path__ + "static/media/5.006cb196.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/landing/reviews/5.png
// module id = 1725
// module chunks = 0